<script setup lang="ts">
import type { FormError, FormErrorEvent, FormSubmitEvent } from "@nuxt/ui"

//import { useLangsStore } from "~~/base/app/stores/langs"
//import { useDataStore } from "~~/base/app/stores/data"
// import { useEmailtemplatesStore } from "~~/base/app/stores/emailtemplates"

// import { string } from "zod"
import { addDoc, collection, Timestamp } from "firebase/firestore"
const LangsStore = useLangsStore()
const DataStore = useDataStore()
const EmailtemplatesStore = useEmailtemplatesStore()

const open = ref(false)

const state_def = {
	email: undefined,
	email_repeat: undefined,
	message: undefined,
}
// const state_def = {
// 	email: undefined,
// 	email_repeat: undefined,
// 	message: undefined,
// }

const state = reactive({ ...state_def })

const validate = (state: any): FormError[] => {
	// const email_regex = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$", "g")

	const errors = []
	if (!state.email) errors.push({ name: "email", message: LangsStore.getLangEntry("main_langs", "global-required") })
	if (state.email && !checkEmailbyRegex(state.email))
		errors.push({ name: "email", message: LangsStore.getLangEntry("main_langs", "global-wrong-email") })

	if (!state.email_repeat)
		errors.push({ name: "email_repeat", message: LangsStore.getLangEntry("main_langs", "global-required") })
	if (state.email_repeat && !checkEmailbyRegex(state.email_repeat))
		errors.push({ name: "email_repeat", message: LangsStore.getLangEntry("main_langs", "global-wrong-email") })

	if (state.email && state.email_repeat && state.email_repeat !== state.email)
		errors.push({
			name: "email_repeat",
			message: LangsStore.getLangEntry("main_langs", "global-wrong-email-duplicate"),
		})

	if (!state.message)
		errors.push({ name: "message", message: LangsStore.getLangEntry("main_langs", "global-required") })
	if (state.message && state.message.length < 5)
		errors.push({ name: "message", message: LangsStore.getLangEntry("main_langs", "global-required") })

	return errors
}

const toast = useToast()
async function onSubmit(event: FormSubmitEvent<typeof state>) {
	console.log(event)

	if (event.data) {
		if (await EmailtemplatesStore.sendEmailTemplate("message-from-website", event.data)) {
			await EmailtemplatesStore.sendEmail({
				to: ["lavinia.mica@dexterial.com"],
				cc: ["contact@dexterial.com"],
				from: event.data.email,
				template_name: "message-to-us-from-website" + "-" + LangsStore.context.lang_id,
				template_data: { message: event.data.message },
			})
		}

		toast.add({
			title: LangsStore.getLangEntry("main_langs", "global-success"),
			description: LangsStore.getLangEntry("main_langs", "dexterial-book-us-success"),
			color: "success",
		})
		console.log(event.data)
	}
}

async function onError(event: FormErrorEvent) {
	console.log(event?.errors)
	if (event?.errors?.[0]?.name) {
		console.log()
		const element = document.getElementById(event.errors[0].name)
		element?.focus()
		element?.scrollIntoView({ behavior: "smooth", block: "center" })
	}
}

defineProps<{
	inbody?: boolean
}>()
</script>

<template>
	<UModal
		v-model:open="open"
		:title="LangsStore.getLangEntry('main_langs', 'dexterial-book-us')"
		:ui="{ footer: 'justify-end', content: 'bg-muted' }"
		:dismissible="false"
		:close="{
			onClick: () => {
				state = { ...state_def }
			},
		}"
	>
		<!-- description="This is useful when you want a form in a Modal." -->

		<UButton
			v-if="inbody"
			:label="LangsStore.getLangEntry('main_langs', 'dexterial-book-us')"
			color="primary"
			size="md"
			variant="solid"
		/>
		<div
			v-else
			class="mt-3"
		>
			<UButton
				:label="LangsStore.getLangEntry('main_langs', 'dexterial-navigation-contact')"
				color="primary"
				size="sm"
				trailing-icon="i-lucide-send-horizontal"
				class="rounded-full"
				:ui="{
					label: 'hidden md:inline-flex',
				}"
			/>
		</div>

		<template #body>
			<div class="flex w-full justify-center pb-4">
				{{ LangsStore.getLangEntry("main_langs", "dexterial-book-us-whatsapp") }}
			</div>

			<div class="flex h-12 w-full justify-center">
				<BasicImageLink
					src="WhatsAppButtonGreenSmall.png"
					:redirect="'https://wa.me/+40770961880'"
					:alt="LangsStore.getLangEntry('base_langs', 'global-whatsapp')"
				/>
				<!-- ?text=Im%20interested%20in%20your%20car%20for%20sale -->
			</div>

			<div class="flex w-full justify-center py-4">
				{{ LangsStore.getLangEntry("main_langs", "dexterial-book-us-message") }}
			</div>

			<UForm
				:validate="validate"
				:state="state"
				class="space-y-4"
				@error="onError($event)"
				@submit="onSubmit($event)"
			>
				<UFormField name="message">
					<!-- :label="getLangEntry('main_langs','global-message')" -->
					<UTextarea
						id="message"
						v-model="state.message"
						class="w-full"
					/>
				</UFormField>

				<div class="sm:flex sm:justify-between">
					<UFormField
						:label="LangsStore.getLangEntry('base_langs', 'global-email')"
						name="email"
					>
						<UInput
							id="email"
							v-model="state.email"
						/>
					</UFormField>

					<UFormField
						:label="LangsStore.getLangEntry('base_langs', 'global-email-repeat')"
						name="email_repeat"
					>
						<UInput
							id="email_repeat"
							v-model="state.email_repeat"
							type="textarea"
						/>
					</UFormField>
				</div>

				<!-- <UButton
					:label="getLangEntry('main_langs','global-cancel')"
					type="button"
					color="neutral"
					variant="outline"
					@click="close"
				/> -->
				<div class="flex justify-center">
					<UButton
						:label="LangsStore.getLangEntry('base_langs', 'global-submit')"
						type="submit"
						color="primary"
						class=""
						trailing-icon="i-lucide-send-horizontal"
					/>
				</div>
				<!-- <UButton type="submit"> Submit </UButton> -->
			</UForm>
		</template>

		<!-- <template #footer="{ close }"> </template> -->
	</UModal>

	<!-- <UButton
		color="primary"
		size="md"
		variant="solid"
		:ui="{ label: 'text-black' }"
		:label="LangsStore.getLangEntry('main_langs','dexterial-book-us')"
	/> -->
</template>
<style lang="css" scoped></style>
